import React, { useState, useEffect } from 'react'
import { useAvailableSlots } from "../store/stateProvider"
import UserInput from '../user-input'
import { style } from './style'
import Drawer from '../../Drawer'
import useBoolean from '../../../hooks/use-boolean'

const PincodeSubHeader = (props) => {
  const [data, dispatch] = useAvailableSlots()
  const { searchByPincode = true, identifier = '' } = data
  const [isOpen, open, close] = useBoolean(false)
  const [expand, setExpand] = useState(true)

  const isExpand = () => {
    setExpand(true)
  }
  const collapse = () => {
    setExpand(false)
  }
  return (
    <>
      <div style={style.pincodeContainer} onClick={() => { open() }}>
        <div style={{ display: 'flex' }} >
          <img src={'/icons/ic_location.jpg'} style={style.locationIcon} />
          <div style={style.aboutText}>
            {`Showing results for ${searchByPincode ? 'pincode ' : 'district'}`}
            {searchByPincode ? <span style={{ fontFamily: 'JioType-Bold' }}>{identifier}</span> : <br />}
            {searchByPincode ? <span /> : <span style={{ fontFamily: 'JioType-Bold' }}>{identifier}</span>}
          </div>
        </div>
        <img src={'/icons/ic_down_arrow.svg'} style={style.downArrowIcon} />
      </div>
      <Drawer open={isOpen}
        heading={<div style={{ display: 'flex' }}> <div>Search by</div></div>}
        BackdropProps={false}
        onClose={close}
        backgroundColor='#ffffff'
        containerPadding={{ padding: '30px 10px 67px' }}
        headingPadding={{ padding: '0px 0px 0px 15px' }}
        height={expand ? '500px' : 'auto'}
      >
        <UserInput closeDrawer={close} isExpand={isExpand} collapse={collapse} />
      </Drawer>
    </>
  )
}

export default PincodeSubHeader
